// Camera transforms for the hex renderer

export function createCamera(x = 0, y = 0, zoom = 1) {
  return { x, y, zoom };
}

export function worldToScreen(cam, canvasWidth, canvasHeight, wx, wy) {
  return {
    x: (wx - cam.x) * cam.zoom + canvasWidth / 2,
    y: (wy - cam.y) * cam.zoom + canvasHeight / 2,
  };
}

export function screenToWorld(cam, canvasWidth, canvasHeight, sx, sy) {
  return {
    x: (sx - canvasWidth / 2) / cam.zoom + cam.x,
    y: (sy - canvasHeight / 2) / cam.zoom + cam.y,
  };
}

/**
 * Get the world-space bounding box of the current viewport.
 */
export function getViewportWorldBounds(cam, canvasWidth, canvasHeight) {
  const tl = screenToWorld(cam, canvasWidth, canvasHeight, 0, 0);
  const br = screenToWorld(cam, canvasWidth, canvasHeight, canvasWidth, canvasHeight);
  return {
    minX: tl.x,
    minY: tl.y,
    maxX: br.x,
    maxY: br.y,
  };
}
